export class DebugManager {
  constructor(className) {
    this.className = className

    this.config = {
      ApiAuth: { bgc: "#8381BA", t: "black" },
      ApiCommon: { bgc: "#DF4BB6", t: "black" },

      QuestionsList: { bgc: "#D3BA11", t: "black" },
      QuestionsManager: { bgc: "#A18654", t: "black" },

      QuestionTypesManager: { bgc: "#E9D71F", t: "black" },
      QuestionTypesList: { bgc: "#981C25", t: "white" },

      ResponseChoicesManager: { bgc: "#BB1066", t: "white" },
      ResponseChoicesList: { bgc: "#4FA2CF", t: "black" },
      ResponseChoiceForm: { bgc: "#B26E6A", t: "black" },

      ResponseTypesManager: { bgc: "#D22C53", t: "white" },
      ResponseTypesList: { bgc: "#45E66A", t: "black" },

      StatisticsManager: { bgc: "#1213D5", t: "white" },

      UsersManager: { bgc: "#C8B0EA", t: "black" },
      UsersList: { bgc: "#2445D2", t: "white" },
      UserForm: { bgc: "#5FF717", t: "black" },
      Dashboard: { bgc: "#E704D5", t: "white" },
      ListPageContainer: { bgc: "#4AC1FA", t: "black" },
      TableOfEntities: { bgc: "#709339", t: "black" },
      getEntitiesUrlParameters: { bgc: "#1C7D55", t: "white" },
      MainApp: { bgc: "#D11E5F", t: "white" },
      Navigation: { bgc: "#DAF18E", t: "black" },
      MyProfileForm: { bgc: "#B6A1C7", t: "black" },
      pyLog: { bgc: "#60B6ED", t: "black" },
      Login: { bgc: "#A45E59", t: "white" },

      Play: { bgc: "#97DA88", t: "black" },
      Question: { bgc: "#8D24CA", t: "white" },
      Splash: { bgc: "#6E74D7", t: "black" },
      // XXXX: true,
    }

    this.activeConfig = {
      // OrderFormReturnLoan: true,
    }

    this.isActive = this.activeConfig[this.className]

    this.init = this.init.bind(this)
    this.rendering = this.rendering.bind(this)
    this.renderDone = this.renderDone.bind(this)
    this.debug = this.debug.bind(this)
    this.activate = this.activate.bind(this)

    this.init()
  }

  activate(isActive) {
    this.isActive = isActive
    this.init()
    // this.debug(". . . . . . . . . . IN CLASS ACTIVATED . . . . . . . . . . ")
  }

  init() {
    if (this.isActive) {
      if (typeof this.config[this.className] !== "object") {
        this.getRandomColor = this.getRandomColor.bind(this)
        this.getContrastingTextColor = this.getContrastingTextColor.bind(this)

        this.backgroundColor = this.getRandomColor()
        this.textColor = this.getContrastingTextColor(this.backgroundColor)

        // this.debug(" -----------------> ADD ME !!!!!!!!!!!!!! ", this.className + ':{bgc:"' + this.backgroundColor + '", t:"' + this.textColor + '"},')
      } else {
        this.backgroundColor = this.config[this.className].bgc
        this.textColor = this.config[this.className].t
      }
      this.debug(". . . . . . . . . . . . . . INIT . . . . . . . . . . . . . . ")
    }
  }

  rendering() {
    this.debug("-------------------------- RENDERING --------------------------")
  }

  renderDone() {
    // this.debug("========================= RENDER DONE =========================")
  }

  delimiter(delimiterName) {
    console.log("- = - = - = - = - = - = - = - = - = - = - " + delimiterName + " - = - = - = - = - = - = - = - = - = - = - ")
  }

  debug(...args) {
    if (this.isActive) {
      console.log(`%c ${this.className} `, `background: ${this.backgroundColor}; color: ${this.textColor}; padding: 2px; font-weight:boldX;`, ...args)
    }
  }

  error(...args) {
    console.error(...args)
  }

  getRandomColor() {
    const letters = "0123456789ABCDEF"
    let color = "#"
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  getContrastingTextColor(hexColor) {
    const r = parseInt(hexColor.slice(1, 3), 16)
    const g = parseInt(hexColor.slice(3, 5), 16)
    const b = parseInt(hexColor.slice(5, 7), 16)

    const brightness = (r * 299 + g * 587 + b * 114) / 1000

    return brightness > 125 ? "black" : "white"
  }
}
